<div class="cabecalho__title">
  <div class="cabecalho__props">
    <div>
      <img class="imagem__logo"
        src="../../../../../assets/images/Relatorios/{{ logoEmpresa ? 'LogoAltaPerformance.PNG' : 'LogoApn.png'}}"
        alt="Logo da Empresa">
    </div>
    <div>
      <p class="dados__cabecalho__inicio">{{ empresaRelatorioCabecalho?.nomeEmpresa }}</p>
      <p class="dados__cabecalho__inicio">{{ empresaRelatorioCabecalho?.enderecoEmpresa }}</p>
    </div>
  </div>
  <div class="cabecalho__props__itens">
    <p class="dados__cabecalho">CNPJ: {{ empresaRelatorioCabecalho?.cnpjEmpresa }}
    </p>
    <p class="dados__cabecalho">www.apnetworks.com.br faturamento@apnetworks.com.br</p>
  </div>
</div>
